import { render, staticRenderFns } from "./SearchVision.vue?vue&type=template&id=6b430a13"
import script from "./SearchVision.vue?vue&type=script&lang=js"
export * from "./SearchVision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports